<phx-modal
  [phxOpen]="phxOpen"
  (phxOpenChange)="phxOpenChange.emit($event)"
  [phxFullScreen]="true"
  [phxHideCloseIcon]="true"
  phxBackground="dark"
  tabindex="0"
  (phxKeyDown)="onKeyDown($event)"
>
  <div phx-modal-header>
    <div class="phx-gallery-header">
      <div class="phx-gallery-titles-container">
        <div class="phx-gallery-title">{{ imageTitle }}</div>
        <div class="phx-gallery-subtitle">{{ 'Item' | phxTranslate }} {{ activeImageIndex }} {{ 'of' | phxTranslate }} {{ imagesCount }}</div>
      </div>
      <div class="phx-gallery-header-actions">
        <button
          *ngIf="phxEditMode"
          phx-icon-button
          [phxIcon]="RotateIcon"
          [phxIconButtonSize]="buttonSize"
          phxIconButtonType="on-bold"
          (click)="onRotateClick()"
        ></button>
        <button
          phx-icon-button
          [phxIcon]="DownloadIcon"
          [phxIconButtonSize]="buttonSize"
          phxIconButtonType="on-bold"
          (click)="onDownloadClick()"
        ></button>
        <button
          *ngIf="phxEditMode"
          phx-icon-button
          [phxIcon]="DeleteIcon"
          [phxIconButtonSize]="buttonSize"
          phxIconButtonType="on-bold"
          (click)="onDeleteClick()"
        ></button>
        <phx-divider class="phx-gallery-actions-divider" phxOrientation="vertical" phxBackground="dark" phxMarginX="none"></phx-divider>
        <button
          phx-icon-button
          [phxIcon]="CloseIcon"
          [phxIconButtonSize]="buttonSize"
          phxIconButtonType="on-bold"
          (click)="onCloseClick()"
        ></button>
      </div>
    </div>
  </div>
  <div phx-modal-body phxNoPadding>
    <div 
      class="phx-gallery-body"
      (wheel)="onMouseWheel($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <button
        *ngIf="imagesCount > 1"
        phx-icon-button
        class="phx-gallery-nav-button phx-gallery-nav-left"
        phxIconButtonSize="extra-extra-large"
        phxIconButtonType="on-bold"
        [phxIcon]="ChevronLeftIcon"
        [disabled]="!hasPreviousImage"
        (click)="onPreviousImage()"
      ></button>
      <ng-container *ngIf="phxOpen">
        <div
          *ngFor="let image of phxImages; let i = index"
          class="phx-gallery-slide"
          [ngClass]="getSlideClasses(i)"
        >
          <phx-image-pan-zoom
            #phxImagePanZoom
            *ngIf="shouldRenderImage(i)"
            [phxImageSrcUrl]="getImageSrc(i)"
            [phxCrossOrigin]="imageCrossOrigin"
            [phxFitToContainer]="true"
            (phxOnImageLoadComplete)="updateZoomPercentage()"
          ></phx-image-pan-zoom>
        </div>
      </ng-container>
      <button
        *ngIf="imagesCount > 1"
        phx-icon-button
        class="phx-gallery-nav-button phx-gallery-nav-right"
        phxIconButtonSize="extra-extra-large"
        phxIconButtonType="on-bold"
        [phxIcon]="ChevronRightIcon"
        [disabled]="!hasNextImage"
        (click)="onNextImage()"
      ></button>
    </div>
  </div>
  <div class="phx-gallery-footer" phx-modal-footer>
    <phx-navigation-button
      phxBackground="dark"
      [phxPrefixIcon]="ZoomOutIcon"
      [phxSuffixIcon]="ZoomInIcon"
      (phxOnLeftNavigation)="onZoomOutClick()"
      (phxOnRightNavigation)="onZoomInClick()"
    >
      {{ zoomPercentage }}
    </phx-navigation-button>
  </div>
</phx-modal>
